import { combineReducers } from 'redux';
import { branchData,getSettings, saveUser, cartReducer } from './reducer';

export default combineReducers({ branchData,settings:getSettings,user:saveUser, cart:cartReducer });

 